import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, delay } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})

export class QnaReportDownloadService {
    private apiURL = window.location.href;

    constructor(private http: HttpClient) {

    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    getAvailableReportsTimeFrames(): Observable<any> {
        return this.http.get<any>(`${this.apiURL}GetAvailableReportTimeframes`).pipe(
            (delay(0)),
            retry(1),
            catchError(this.handleError)
        );
    }

    downloadReports(timeFrame): Observable<any> {
        return this.http.get(`${this.apiURL}DownloadReport?timeFrame=${timeFrame}`, { responseType: 'arraybuffer' });
    }

        handleError(error) {
            let errorMessage = '';
            if (error.error instanceof ErrorEvent) {
                // Get client-side error
                errorMessage = error.error.message;
            } else {
                // Get server-side error
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            }
            console.log(errorMessage);
            return throwError(errorMessage);
        }
    }
